var image_viewer_rtlignore_default = {
  "fontElementMap": "a-KRT",
  "imageContainer": "_190tN",
  "expandButton": "_0jLTI",
  "expandIcon": "ThymK",
  "pointer": "YD-JE",
  "imageWrapper": "WziLE",
  "imageRatio": "rxuy8",
  "image": "YM5w6",
  "imageOverlay": "RoZ1P",
  "imagePreload": "_9CSRx",
  "imageHighres": "n3lx-",
  "onlyHighRes": "GhSzu",
  "image_loading": "zBe61"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
